import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const StatInfos = React.lazy(() => import('./index'));
const StatInfoTable = React.lazy(() => import('./statInfoTable'));

export const useStatInfoRoutes = () => {

    return (
        <Route path="statInfos" element={<Suspense fallback={<div>منتظر باشید...</div>}><StatInfos /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><StatInfoTable/></Suspense> } />
        </Route>
    )
}